"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAllFulfillers = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fetchAllFulfillers = function fetchAllFulfillers(accessToken) {
  return _axios["default"].get('https://fulfilleridentity.trdlnk.cimpress.io/v1/fulfillers?showArchived=false', {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data.map(function (fulfiller) {
      return {
        entityId: fulfiller.fulfillerId,
        entityType: 'Fulfiller',
        entityName: fulfiller.name
      };
    });
  });
};
exports.fetchAllFulfillers = fetchAllFulfillers;